import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "operates" }
const _hoisted_2 = {
  key: 1,
  class: "drag-mask"
}
const _hoisted_3 = { class: "center-btns" }
const _hoisted_4 = {
  class: "center-operate",
  style: {"display":"none"}
}
const _hoisted_5 = {
  class: "btns-flex",
  style: {"margin-right":"10px"}
}
const _hoisted_6 = { class: "btns-flex" }
const _hoisted_7 = { style: {"padding-top":"25px"} }
const _hoisted_8 = { class: "viewport-size-preset" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElementCreateSelection = _resolveComponent("ElementCreateSelection")!
  const _component_AlignmentLine = _resolveComponent("AlignmentLine")!
  const _component_MultiSelectOperate = _resolveComponent("MultiSelectOperate")!
  const _component_Operate = _resolveComponent("Operate")!
  const _component_ViewportBackground = _resolveComponent("ViewportBackground")!
  const _component_MouseSelection = _resolveComponent("MouseSelection")!
  const _component_EditableElement = _resolveComponent("EditableElement")!
  const _component_Ruler = _resolveComponent("Ruler")!
  const _component_LinkDialog = _resolveComponent("LinkDialog")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Copy = _resolveComponent("Copy")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_UpC = _resolveComponent("UpC")!
  const _component_DownC = _resolveComponent("DownC")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_AddItem = _resolveComponent("AddItem")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_IconMinus = _resolveComponent("IconMinus")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_IconPlus = _resolveComponent("IconPlus")!
  const _directive_contextmenu = _resolveDirective("contextmenu")!
  const _directive_click_outside = _resolveDirective("click-outside")!
  const _directive_click_menu = _resolveDirective("click-menu")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "canvas",
    ref: "canvasRef",
    onWheel: _cache[12] || (_cache[12] = $event => _ctx.handleMousewheelCanvas($event)),
    onMousedown: _cache[13] || (_cache[13] = $event => _ctx.handleClickBlankArea($event))
  }, [
    (_ctx.creatingElement)
      ? (_openBlock(), _createBlock(_component_ElementCreateSelection, {
          key: 0,
          onCreated: _cache[0] || (_cache[0] = data => _ctx.insertElementFromCreateSelection(data))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "viewport-wrapper",
      style: _normalizeStyle({
        width: _ctx.viewportStyles.width * _ctx.canvasScale + 'px',
        height: _ctx.viewportStyles.height * _ctx.canvasScale + 'px',
        left: _ctx.viewportStyles.left + 'px',
        top: _ctx.viewportStyles.top + 'px',
      })
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alignmentLines, (line, index) => {
          return (_openBlock(), _createBlock(_component_AlignmentLine, {
            key: index,
            type: line.type,
            axis: line.axis,
            length: line.length
          }, null, 8, ["type", "axis", "length"]))
        }), 128)),
        (_ctx.activeElementIdList.length > 1)
          ? (_openBlock(), _createBlock(_component_MultiSelectOperate, {
              key: 0,
              elementList: _ctx.elementList,
              scaleMultiElement: _ctx.scaleMultiElement
            }, null, 8, ["elementList", "scaleMultiElement"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elementList, (element) => {
          return (_openBlock(), _createBlock(_component_Operate, {
            key: element.id,
            elementInfo: element,
            isSelected: _ctx.activeElementIdList.includes(element.id),
            isActive: _ctx.handleElementId === element.id,
            isActiveGroupElement: _ctx.activeGroupElementId === element.id,
            isMultiSelect: _ctx.activeElementIdList.length > 1,
            rotateElement: _ctx.rotateElement,
            scaleElement: _ctx.scaleElement,
            openLinkDialog: _ctx.openLinkDialog,
            dragLineElement: _ctx.dragLineElement
          }, null, 8, ["elementInfo", "isSelected", "isActive", "isActiveGroupElement", "isMultiSelect", "rotateElement", "scaleElement", "openLinkDialog", "dragLineElement"]))
        }), 128)),
        _createVNode(_component_ViewportBackground)
      ]),
      _createElementVNode("div", {
        class: "viewport",
        ref: "viewportRef",
        style: _normalizeStyle({ transform: `scale(${_ctx.canvasScale})` })
      }, [
        (_ctx.mouseSelectionVisible)
          ? (_openBlock(), _createBlock(_component_MouseSelection, {
              key: 0,
              top: _ctx.mouseSelection.top,
              left: _ctx.mouseSelection.left,
              width: _ctx.mouseSelection.width,
              height: _ctx.mouseSelection.height,
              quadrant: _ctx.mouseSelectionQuadrant
            }, null, 8, ["top", "left", "width", "height", "quadrant"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elementList, (element, index) => {
          return (_openBlock(), _createBlock(_component_EditableElement, {
            key: element.id,
            elementInfo: element,
            elementIndex: index + 1,
            isMultiSelect: _ctx.activeElementIdList.length > 1,
            selectElement: _ctx.selectElement,
            openLinkDialog: _ctx.openLinkDialog
          }, null, 8, ["elementInfo", "elementIndex", "isMultiSelect", "selectElement", "openLinkDialog"]))
        }), 128))
      ], 4)
    ], 4),
    (_ctx.spaceKeyState)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.showRuler)
      ? (_openBlock(), _createBlock(_component_Ruler, {
          key: 2,
          viewportStyles: _ctx.viewportStyles
        }, null, 8, ["viewportStyles"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Modal, {
      visible: _ctx.linkDialogVisible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.linkDialogVisible) = $event)),
      footer: null,
      centered: "",
      width: 540,
      destroyOnClose: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_LinkDialog, {
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.linkDialogVisible = false))
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createElementVNode("div", _hoisted_3, [
      _cache[14] || (_cache[14] = _createElementVNode("div", null, null, -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Tooltip, {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "复制"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyAndPasteSlide()))
              }, [
                _createVNode(_component_Copy, { class: "btn-image" })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Tooltip, {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "上移"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.pageChange(-1)))
              }, [
                _createVNode(_component_UpC, { class: "btn-image" })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Tooltip, {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "下移"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.pageChange(1)))
              }, [
                _createVNode(_component_DownC, { class: "btn-image" })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Tooltip, {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "删除"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteSlide()))
              }, [
                _createVNode(_component_Delete, { class: "btn-image" })
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Tooltip, {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "添加幻灯片"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.createSlide()))
              }, [
                _createVNode(_component_AddItem, { class: "btn-image" })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Tooltip, {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "演讲备注"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openRemark()))
              }, [
                _createVNode(_component_Tag, { class: "btn-image" })
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_IconMinus, {
          class: "handler-item viewport-size",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.scaleCanvas('-')))
        }),
        _createVNode(_component_Popover, {
          trigger: "click",
          visible: _ctx.canvasScaleVisible,
          "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.canvasScaleVisible) = $event))
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canvasScalePresetList, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "preset-item",
                  key: item,
                  onClick: ($event: any) => (_ctx.applyCanvasPresetScale(item))
                }, _toDisplayString(item) + "% ", 9, _hoisted_9))
              }), 128))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.canvasScalePercentage), 1)
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_IconPlus, {
          class: "handler-item viewport-size",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.scaleCanvas('+')))
        })
      ])
    ])
  ], 32)), [
    [_directive_contextmenu, _ctx.contextmenus],
    [_directive_click_outside, _ctx.removeEditorAreaFocus],
    [_directive_click_menu, _ctx.operateMenus]
  ])
}